import { cn } from "@/lib/utils";
import Screen from "@/src/components/Screen";
import { textVariants } from "@/src/components/Text/Text";
import { NavLink, Outlet } from "react-router-dom";
import { Tabs } from "@mantine/core";
import { useTranslation } from "react-i18next";

const Rewards = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.referAndEarn.tabs.${key}`);
  // const { pathname } = useLocation()
  return (
    <>
      <div className="bg-white border-b border-gray-100 dark:bg-grey-600 dark:border-grey-500 px-3 md:p-0">
        <div className="pt-6 max-w-screen-xl mx-auto md:px-4 flex items-center justify-between">
          <Tabs defaultValue="refer">
            <Tabs.List>
              <NavLink to={"/app/earn"}>
                <Tabs.Tab
                  value="refer"
                  className={cn(
                    textVariants({ size: "md" }),
                    "dark:text-white dark:hover:text-white dark:hover:bg-[#212741]"
                  )}
                >
                  <span>{trans("refer")}</span>
                </Tabs.Tab>
              </NavLink>
              <NavLink to={"/app/earn/rewards"}>
                <Tabs.Tab
                  value="rewards"
                  className={cn(
                    textVariants({ size: "md" }),
                    "dark:text-white dark:hover:text-white dark:hover:bg-[#212741]"
                  )}
                >
                  <span>{trans("rewards")}</span>
                </Tabs.Tab>
              </NavLink>
              <NavLink to={"/app/earn/scan"}>
                <Tabs.Tab
                  value="scan"
                  className={cn(
                    textVariants({ size: "md" }),
                    "dark:text-white dark:hover:text-white dark:hover:bg-[#212741]"
                  )}
                >
                  <span>Scan & Win</span>
                </Tabs.Tab>
              </NavLink>
            </Tabs.List>
          </Tabs>
        </div>
      </div>
      <Screen>
        <Outlet />
      </Screen>
    </>
  );
};

export default Rewards;
